<template>
  <slot name="activator" v-bind="{ activator }"/>

  <modal
    scrollable
    size="screen"
    slide="up"
    v-bind="{ show, title }"
    @close="close"
  >
    <div class="flex flex-col grow items-center justify-center" @click.prevent="click">
      <slot/>
    </div>
  </modal>
</template>

<script setup>
import Modal from "@/components/modals/Modal.vue"
import { nextTick, ref } from "vue"

const props = defineProps({
  title: String,
  icon: String,
  autoopen: Boolean,
})

const show = ref(false)

const activator = () => {
  show.value = true
}

const click = ($event) => {
  if ($event.target.parentElement.href ?? $event.target.href) {
    window.open($event.target.parentElement.href ?? $event.target.href)
  }
}

const close = () => {
  show.value = false
}

nextTick(() => {
  if (props.autoopen) {
    activator()
  }
})
</script>
